// BrowseContractors.tsx - Directory section extracted from HomePage
import React from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col, Card, CardBody } from "reactstrap";
import { MapPin, Wrench, Search } from "lucide-react";

// SEO-friendly state and category data
const FEATURED_STATES = [
  { name: "Virginia", slug: "va", cities: ["Virginia Beach", "Chesapeake", "Norfolk", "Richmond"] },
  { name: "North Carolina", slug: "nc", cities: ["Charlotte", "Raleigh", "Durham", "Greensboro"] },
  { name: "Maryland", slug: "md", cities: ["Baltimore", "Annapolis", "Frederick", "Rockville"] },
  { name: "Florida", slug: "fl", cities: ["Miami", "Tampa", "Orlando", "Jacksonville"] },
  { name: "Texas", slug: "tx", cities: ["Houston", "Dallas", "Austin", "San Antonio"] },
  { name: "California", slug: "ca", cities: ["Los Angeles", "San Francisco", "San Diego", "Sacramento"] }
];

const FEATURED_CATEGORIES = [
  { name: "General Contractors", slug: "general-contractors" },
  { name: "Roofing Contractors", slug: "roofing-contractors" },
  { name: "Plumbers", slug: "plumbers" },
  { name: "Electricians", slug: "electricians" },
  { name: "HVAC Contractors", slug: "hvac-contractors" },
  { name: "Bathroom Remodeling", slug: "bathroom-remodeling" },
  { name: "Kitchen Remodeling", slug: "kitchen-planning-remodeling-service" },
  { name: "Home Improvement", slug: "home-improvements" }
];

const BrowseContractors: React.FC = () => {
  return (
    <section className="py-5 bg-light">
      <Container>
        <Row className="justify-content-center">
          <Col lg={10}>
            <div className="text-center mb-5">
              <h2 className="mb-3">Find Contractors in Your Area</h2>
              <p className="text-muted fs-5">
                Browse trusted professionals by location and service category
              </p>
            </div>

            {/* Quick Access Links */}
            <Row className="mb-5">
              <Col md={6} className="mb-3">
                <Card className="h-100 border-primary">
                  <CardBody className="text-center">
                    <MapPin className="text-primary mb-3" size={48} />
                    <h4>Browse Job Postings</h4>
                    <p className="text-muted mb-3">Explore Construction Projects By Location</p>
                    <Link to="/jobs" className="btn btn-primary">
                      View Job Postings
                    </Link>
                  </CardBody>
                </Card>
              </Col>
              <Col md={6} className="mb-3">
                <Card className="h-100 border-success">
                  <CardBody className="text-center">
                    <Wrench className="text-success mb-3" size={48} />
                    <h4>Browse Contractor Listings</h4>
                    <p className="text-muted mb-3">Explore contractor listings & profiles</p>
                    <Link to="/contractors/locations" className="btn btn-success">
                      View Contractors
                    </Link>
                  </CardBody>
                </Card>
              </Col>
            </Row>

           

         
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default BrowseContractors;